import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';
import { apiChat as http } from '../../../http';
import { apiChatTS } from '../../../http';

class ChatDialogTreeService extends ServiceCRUD {
  constructor() {
    super('/dialog/chat');
  }

  getActionDialogTree = () => {
    return http.get(`${this.path}/action`);
  };

  getAllSearch = (page, size, query) => {
    if (query !== '') {
      return http.get(`${this.path}?name=${query}`, {
        headers: {
          limit: size,
          offset: size * (page - 1)
        }
      });
    } else {
      return http.get(`${this.path}`, {
        headers: {
          limit: size,
          offset: size * (page - 1)
        }
      });
    }
  };

  putDialogTree = (id, data) => {
    return http.put(`${this.path}/${id}`, data);
  };

  postDialogTree = (data) => {
    return http.post(`${this.path}`, data);
  };

  deleteDialogTree = (id) => {
    return http.delete(`${this.path}/${id}`);
  };

  getTreeById = (id) => {
    return http.get(`${this.path}/${id}`);
  };

  getDialogTreeResume = () => {
    return http.get(`${this.path}/resume/all`);
  };

  addAttachment = (formData) => {
    return apiChatTS.post(`${this.path}/dialog-attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'local-upload': 'treeChatBot'
      }
    });
  };

  deleteAttachment = (fileName) => {
    return apiChatTS.delete(`${this.path}/dialog-attachment/${fileName}`);
  };
}

export default new ChatDialogTreeService();
